import { render, staticRenderFns } from "./MenuLateral.vue?vue&type=template&id=0544395a&scoped=true"
import script from "./MenuLateral.vue?vue&type=script&lang=js"
export * from "./MenuLateral.vue?vue&type=script&lang=js"
import style0 from "./MenuLateral.vue?vue&type=style&index=0&id=0544395a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0544395a",
  null
  
)

export default component.exports